import {asset} from 'imba';
import url from './solution.png';
export default asset({
	url: url,
	type: 'image',
	width: 2404,
	height: 643,
	toString: function(){ return this.url;}
})